module.exports = __webpack_public_path__ + "img/career-map.eb360735.png";